<template>
  <v-img class="img" :src="src" :lazy-src="src" :cover="cover" :transition="transition" :gradient="gradient"></v-img>
</template>

<script>
import Tcb from '@/tcb'
export default {
  props: {
    cloudPath: String,
    cover: Boolean,
    transition: String,
    gradient: String
  },
  data: () => ({
    src: ''
  }),
  async created () {
    const res = await Tcb.getTempFileURL({
      fileList: [this.cloudPath]
    })
    if (res.fileList[0].code === 'SUCCESS') {
      this.src = res.fileList[0].tempFileURL
    }
  }
}
</script>
